import * as React from "react";

export type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> & {
  onCheckedChange?: (checked: boolean) => void;
};

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = "", onCheckedChange, ...props }, ref) => {
    const base =
      "h-4 w-4 rounded border border-neutral-300 text-neutral-900 focus:ring-2 focus:ring-neutral-800 focus:outline-none";
    return (
      <input
        ref={ref}
        type="checkbox"
        className={`${base} ${className}`}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        {...props as any}
      />
    );
  }
);

Checkbox.displayName = "Checkbox";
